import {Box} from "@mui/system";
import styles from "../Proactive/Utilities/templateStyles";
import CircularProgress from "@mui/material/CircularProgress";
import BasicTable from "../../common/BasicTable";

export default function ExpertPaymentTable({ rows, columns, totalCount, page, loading, handlePageChange, clickable }) {
    if(loading && _.isEmpty(rows)) {
        return(
            <Box sx={styles.emptyContainer}>
                <CircularProgress size={25} sx={{ color: '#003300'}}/>
            </Box>
        )
    }

    return (
        <BasicTable
            rows={rows}
            columns={columns}
            totalCount={totalCount}
            handlePageChange={handlePageChange}
            page={page}
            isPaginationDisabled={loading}
            clickable={clickable}
        />
    );
}